import React, {useState, useEffect, useRef} from 'react';
import {Drawer, Box, IconButton, Typography} from '@mui/material';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';

const images = [
  `${process.env.REACT_APP_CDN}/motorcycle-facts/bike.png`,
  `${process.env.REACT_APP_CDN}/motorcycle-facts/bike1.png`,
  `${process.env.REACT_APP_CDN}/motorcycle-facts/bike2.png`,
  `${process.env.REACT_APP_CDN}/motorcycle-facts/bike3.png`,
];

const SliderWithDrawer = ({openDrawer, setOpenDrawer}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const sliderRef = useRef(null);
  const drawerRef = useRef(null); // Ref for the drawer to track its scroll position

  // Function to move to the next slide
  const nextSlide = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    setCurrentIndex(nextIndex);
    scrollToSlide(nextIndex);
  };

  // Function to move to the previous slide
  const prevSlide = () => {
    const prevIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
    setCurrentIndex(prevIndex);
    scrollToSlide(prevIndex);
  };

  // Scroll to the specific slide
  const scrollToSlide = index => {
    if (sliderRef.current) {
      const slide = sliderRef.current.children[index];
      slide.scrollIntoView({behavior: 'smooth'});
    }
  };

  // Automatic slide change every 3 seconds
  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <Drawer
      anchor="bottom"
      open={openDrawer}
      onClose={() => setOpenDrawer(false)}
      sx={{
        '& .MuiDrawer-paper': {
          height: '80%', // Leaves 30% of the screen at the top
          width: '100%',
          backgroundColor: '#1E1E1E', // Set background color to #1E1E1E
          overflowY: 'auto', // Enable vertical scrolling
        },
      }}
      ref={drawerRef} // Attach ref to the Drawer
    >
      <Box sx={{width: '100%', height: '100%', position: 'relative'}}>
        {/* Slider Section */}
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            height: '40vh',
            overflow: 'hidden',
          }}
        >
          <Box
            ref={sliderRef}
            sx={{
              display: 'flex',
              scrollSnapType: 'x mandatory', // Ensures snapping to slides
              overflowX: 'auto', // Enables horizontal scroll
              height: '100%',
              width: '100%',
              scrollBehavior: 'smooth',
            }}
          >
            {images.map((image, index) => (
              <Box
                key={index}
                component="img"
                src={image}
                alt={`Slide ${index + 1}`}
                sx={{
                  flexShrink: 0, // Prevent images from shrinking
                  width: '100%', // Ensure each image takes full width of the container
                  height: '100%', // Ensure each image takes full height of the container
                  objectFit: 'cover', // Make sure the image covers the area without stretching
                  scrollSnapAlign: 'start', // Ensures snap aligns to the start of each image
                }}
              />
            ))}
          </Box>

          {/* Left Arrow */}
          <IconButton
            onClick={prevSlide}
            sx={{
              position: 'absolute',
              top: '50%',
              left: '16px',
              transform: 'translateY(-50%)',
              zIndex: 10,
              color: 'white',
            }}
          >
            <ArrowLeftIcon
              style={{
                fontSize: '40px',
                color: '#D9D9D9',
              }}
            />
          </IconButton>

          {/* Right Arrow */}
          <IconButton
            onClick={nextSlide}
            sx={{
              position: 'absolute',
              top: '50%',
              right: '16px',
              transform: 'translateY(-50%)',
              zIndex: 10,
              color: 'white',
            }}
          >
            <ArrowRightIcon
              style={{
                fontSize: '40px',
                color: '#D9D9D9',
              }}
            />
          </IconButton>
        </Box>

        {/* Heading and Subtitle Section */}
        <Box sx={{padding: '30px', textAlign: 'left'}}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: '500',
              fontSize: '24px',
              marginBottom: '8px',
              color: '#FFFFFF',
              fontFamily: 'Klapt',
            }}
          >
            420 MPH LEGEND <br />
            NO ONE DARED TO RIDE
          </Typography>
          <Typography
            variant="body1"
            sx={{
              color: '#818D93',
              fontSize: '14px',
              fontWeight: '400',
              fontFamily: 'Archivo',
            }}
          >
            In 2003, Dodge introduced the Tomahawk, one of the wildest concept
            motorcycles ever created. It was powered by an 8.3-liter V10 engine
            from the Dodge Viper, with a theoretical top speed of 420 mph. For
            context, the Kawasaki Ninja H2R, the fastest production motorcycle
            today, tops out at 249 mph. The Tomahawk’s incredible speed remains
            unverified, as no one has dared to test it in the real world.
          </Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default SliderWithDrawer;
